export default "__VITE_ASSET__DeVci9pw__"